/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Security_Totp_Remove_DescriptionInputs */



/**
* | output |
* | --- |
* | "Enter your recovery code to remove '{name}'. If this is your only TOTP device, you'll need to use your recovery code to sign in via email link." |
*
* @param {Profile_Security_Totp_Remove_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_totp_remove_description = /** @type {((inputs: Profile_Security_Totp_Remove_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Totp_Remove_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gib deinen Wiederherstellungscode ein, um '${i?.name}' zu entfernen. Wenn dies dein einziges TOTP-Gerät ist, musst du den Wiederherstellungscode verwenden, um dich per E-Mail-Link anzumelden.`)
	return /** @type {LocalizedString} */ (`Enter your recovery code to remove '${i?.name}'. If this is your only TOTP device, you'll need to use your recovery code to sign in via email link.`)
});